export interface User {
  uid?: string;
  role?: string; //administrator / moderator / freelancer / student
  displayName?: string;
  email: string;
  photoURL?: string;
  password?: string;
  disabled?: boolean;

  admin?: boolean;
  moderator?: boolean;
  tutor?: boolean;
  student?: boolean;
  freelancer?: boolean;
  schoolId?: string;
}

export class UserData {
  uid?: string;
  email: string;
  role?: string;
  displayName?: string;
  photoURL?: string;

  coins?: number;
  stars?: number;
  hearts?: number;
  noLiked?: number;

  students?: number;
  sharingCourses?: number;
  learningCourses?: number;
  sharingQuizzes?: number;
  learningQuizzes?: number;

  sharingLectures?: number;
  notifications?: number;

  schoolId?: string;
  createdOn?: Date;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}
